import { useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import DynamicTable from "src/components/table";
import {
  columntype,
  dataLocalStorage,
  getLocalStorage,
  inputType,
  isValidArray,
} from "src/helper/publicFunction";
import {
  ManageGalleries,
  DeleteGalleries,
  EditGalleries,
  GetGalleries,
} from "./actions";
import DynamicModal from "src/components/modal/DynamicModal";
import * as Yup from "yup";
import { CommonAlert } from "src/components/alert/CommonAlert";
import { Button } from "@mui/material";
import { IconArrowLeft } from "@tabler/icons";

const Galleries = () => {
  const navigate = useNavigate();
  const { type, related_id } = useParams();
  const dispatch = useDispatch();
  const Commonalert = CommonAlert();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [loadingEditdatatype, setloadingEditdatatype] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [array, setarray] = useState([]);
  const [values, setvalues] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [data, setData] = useState([]);
  const [TotalData, setTotalData] = useState(0);
  
  const privilegeId = "13"; 
  let dataPrivileges = getLocalStorage(dataLocalStorage.privileges);
  
  // Determine gallery_type and related_id based on route params
  const getGalleryType = () => {
    if (type === "media_post") return "event"; // or "news" based on media_post type
    if (type === "section") return "section";
    return "general";
  };

  const Schema = Yup.object().shape({
    title: Yup.string().trim().required("Title is required"),
    gallery_type: Yup.string().required("Gallery type is required"),
  });

  const GetData = () => {
    setLoadingData(true);
    setData([]);
    
    const gallery_type = getGalleryType();
    const media_post_id = type === "media_post" ? related_id : null;
    const section_id = type === "section" ? related_id : null;

    dispatch(
      GetGalleries({
        callback: (response) => {
          const responseData = response?.data;
          
          // Filter by related_id if provided
          let filteredData = responseData;
          if (isValidArray(responseData)) {
            if (media_post_id) {
              filteredData = responseData.filter(g => g.media_post_id == media_post_id);
            } else if (section_id) {
              filteredData = responseData.filter(g => g.section_id == section_id);
            }
          }
          
          if (filteredData && typeof filteredData === 'object' && !Array.isArray(filteredData)) {
            setData([filteredData]);
            setTotalData(1);
          } else if (isValidArray(filteredData)) {
            setData(filteredData);
            setTotalData(filteredData.length);
          } else {
            setData([]);
            setTotalData(0);
          }
          setLoadingData(false);
        },
        gallery_type,
        media_post_id,
        section_id,
      })
    );
    
    if (array.length === 0) {
      setarray([
        {
          failed: "id",
          type: inputType.text,
          title: "id",
          placeholder: "",
          fullwidth: true,
          customdesign: { display: "none" },
        },
        {
          failed: "title",
          type: inputType.text,
          title: "Title",
          placeholder: "Enter title",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
        {
          failed: "description",
          type: inputType.textarea,
          title: "Description",
          placeholder: "Enter description",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
        {
          failed: "gallery_type",
          type: inputType.dropdown,
          title: "Gallery Type",
          placeholder: "Select gallery type",
          fullwidth: true,
          customdesign: { width: "100%" },
          datadropdown: [
            { value: "general", name: "General" },
            { value: "event", name: "Event" },
            { value: "news", name: "News" },
            { value: "section", name: "Section" },
          ],
          faileddropdown: { value: "value", name: "name" },
        },
        {
          failed: "media_post_id",
          type: inputType.number,
          title: "Media Post ID",
          placeholder: "Enter media post ID",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
        {
          failed: "section_id",
          type: inputType.number,
          title: "Section ID",
          placeholder: "Enter section ID",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
        {
          failed: "display_order",
          type: inputType.number,
          title: "Display Order",
          placeholder: "Enter display order",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
        {
          failed: "is_active",
          type: inputType.checkbox,
          title: "Is Active",
          placeholder: "",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
      ]);
    }
  };

  useEffect(() => {
    GetData();
  }, [page, rowsPerPage, search, type, related_id]);

  const columns = [
    { type: columntype.text, name: "id" },
    { type: columntype.text, name: "title" },
    { type: columntype.text, name: "description", isSmall: "true" },
    { type: columntype.text, name: "gallery_type" },
    { type: columntype.text, name: "display_order" },
    { type: columntype.boolean, name: "is_active" },
  ];

  const headCells = [
    {
      id: "id",
      numeric: false,
      disablePadding: false,
      label: "ID",
      withSort: true,
    },
    {
      id: "title",
      numeric: false,
      disablePadding: false,
      label: "Title",
      withSort: false,
    },
    {
      id: "description",
      numeric: false,
      disablePadding: false,
      label: "Description",
      withSort: false,
    },
    {
      id: "gallery_type",
      numeric: false,
      disablePadding: false,
      label: "Gallery Type",
      withSort: false,
    },
    {
      id: "display_order",
      numeric: false,
      disablePadding: false,
      label: "Display Order",
      withSort: false,
    },
    {
      id: "is_active",
      numeric: false,
      disablePadding: false,
      label: "Is Active",
      withSort: false,
    },
    (dataPrivileges[privilegeId]?.access_edit == 1 ||
      dataPrivileges[privilegeId]?.access_delete == 1) && {
      id: "action",
      numeric: false,
      disablePadding: false,
      label: "Actions",
      withSort: false,
    },
  ];
  
  const List = [
    dataPrivileges[privilegeId]?.access_delete == 1 && {
      name: "Delete",
      function: async (row) => {
        if (row) {
          Commonalert.show({
            title: `Delete ${row?.title ?? "this item"}?`,
            message: "You won't be able to revert this!",
            type: "delete",
            actions: [
              {
                name: "Yes",
                callback: () =>
                  dispatch(
                    DeleteGalleries({
                      callback: () => GetData(),
                      id: [row?.id],
                    })
                  ),
                type: "delete",
              },
              {
                name: "No",
                callback: () => {},
                type: "cancel",
              },
            ],
          });
        }
      },
    },
    dataPrivileges[privilegeId]?.access_edit == 1 && {
      name: "Edit",
      function: async (data) => {
        setEditMode(true);
        setvalues(data);
        setShowModal(true);
      },
    },
    {
      name: "Gallery Items",
      function: async (row) => {
        navigate(`/gallery-items/${row.id}`);
      },
    },
  ];

  const updateDataApi = ({ row, failedName, newData }) => {
    setloadingEditdatatype(`${row?.id}-${failedName}`);
    dispatch(
      EditGalleries({
        id: row?.id,
        dataFailed: newData,
        nameFailed: failedName,
        callback: () => {
          updateDataLocal({ id: row.id, failedName, newData });
          GetData();
        },
      })
    );
  };

  const updateDataLocal = ({ id, failedName, newData }) => {
    setData((prevData) => 
      prevData.map(item => 
        item.id === id ? {...item, [failedName]: newData} : item
      )
    );
    setloadingEditdatatype("");
  };

  return (
    <div>
      <Button
        startIcon={<IconArrowLeft />}
        onClick={() => navigate(-1)}
        sx={{ mb: 2 }}
      >
        Back
      </Button>

      <DynamicTable
        handleSearch={setSearch}
        onRequestSort={(tableName, sortType) => tableName && sortType && GetData({ tableName, type: sortType })}
        onPressDelete={(ListIds) => {
          Commonalert.show({
            title: "Confirm Delete",
            message: `Delete ${ListIds.length} item(s)?`,
            type: "delete",
            actions: [
              {
                name: "Yes",
                callback: () =>
                  dispatch(
                    DeleteGalleries({
                      callback: () => GetData(),
                      id: ListIds,
                    })
                  ),
                type: "delete",
              },
              {
                name: "No",
                callback: () => {},
                type: "cancel",
              },
            ],
          });
        }}
        onPressItem={() => {}}
        onPressAnyAction={updateDataApi}
        onPressAdd={() => {
          setvalues({
            gallery_type: getGalleryType(),
            media_post_id: type === "media_post" ? related_id : null,
            section_id: type === "section" ? related_id : null,
          });
          setEditMode(false);
          setShowModal(true);
        }}
        items={data}
        columns={columns}
        headCells={headCells}
        page={page}
        setPage={setPage}
        selected={selected}
        setSelected={setSelected}
        search={search}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        Listdropdown={List}
        withOption={true}
        loadingData={loadingData}
        rowsPerPageOptions={[5, 10, 25, 50]}
        totalItem={TotalData}
        loadingEditdatatype={loadingEditdatatype}
        withAddButton={dataPrivileges[privilegeId]?.access_write == 1}
        withDeleteItem={dataPrivileges[privilegeId]?.access_delete == 1}
        withEditItem={dataPrivileges[privilegeId]?.access_edit == 1}
        withPagination={false}
        withSearch={false}
      />
      
      {showModal && (
        <DynamicModal
          show={showModal}
          setShow={setShowModal}
          faileds={array}
          values={values}
          title={"Galleries"}
          editMode={editMode}
          description={editMode ? "Edit Gallery" : "Add New Gallery"}
          buttonTitle={editMode ? "Update" : "Create"}
          onSubmit={(values) => {
            dispatch(
              ManageGalleries({
                editMode,
                values,
                callback: (res) => {
                  if (res) {
                    setShowModal(false);
                    GetData();
                  }
                },
              })
            );
          }}
          Schema={Schema}
        />
      )}
    </div>
  );
};

export default Galleries;

